export default __webpack_public_path__ + "static/media/team4.6e9b54ba.png";